/* eslint-disable */
import {TypedDocumentNode as DocumentNode} from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  Int64: {input: any; output: any};
  Time: {input: any; output: any};
  Void: {input: any; output: any};
};

export type Account = {
  devices?: Maybe<Array<Device>>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  type: AccountType;
};

export enum AccountType {
  Associate = 'ASSOCIATE',
  Bot = 'BOT',
  Client = 'CLIENT',
  Staff = 'STAFF',
  Unknown = 'UNKNOWN',
}

export type AssociateAccount = Account &
  Node & {
    __typename?: 'AssociateAccount';
    client: ClientAccount;
    devices?: Maybe<Array<Device>>;
    firstName: Scalars['String']['output'];
    fsmState?: Maybe<Scalars['String']['output']>;
    fullName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    language: Scalars['String']['output'];
    lastName: Scalars['String']['output'];
    mobilePhoneNumber: Scalars['String']['output'];
    notes: Scalars['String']['output'];
    relationToClient: Scalars['String']['output'];
    twilioNumber: Scalars['String']['output'];
    type: AccountType;
  };

export type BadgeInfo = {
  __typename?: 'BadgeInfo';
  unread: Scalars['Int64']['output'];
};

export type ChatThread = {
  __typename?: 'ChatThread';
  client: Account;
  latest: NotifInfo;
};

export type ClientAccount = Account &
  Node & {
    __typename?: 'ClientAccount';
    address: Scalars['String']['output'];
    assignedStaff: Array<StaffAccount>;
    associatedContacts: Array<AssociateAccount>;
    consented?: Maybe<Scalars['Boolean']['output']>;
    courtDates: Array<CourtAppearance>;
    devices?: Maybe<Array<Device>>;
    email: Scalars['String']['output'];
    externalAppLink?: Maybe<Scalars['String']['output']>;
    firstName: Scalars['String']['output'];
    fsmGraph: Scalars['String']['output'];
    fsmState?: Maybe<Scalars['String']['output']>;
    fullName: Scalars['String']['output'];
    gender: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    isActive: Scalars['Boolean']['output'];
    isLead: Scalars['Boolean']['output'];
    language: Scalars['String']['output'];
    lastMessage?: Maybe<Message>;
    lastName: Scalars['String']['output'];
    leadID?: Maybe<Scalars['String']['output']>;
    messageHistory: Array<Message>;
    mobilePhoneNumber: Scalars['String']['output'];
    nextCourtDate?: Maybe<CourtAppearance>;
    /** @deprecated Use `assignedStaff` field instead to support multiple staff assignments. */
    primaryStaffId?: Maybe<Scalars['ID']['output']>;
    releaseConditions: Scalars['String']['output'];
    returnStrategies: Scalars['String']['output'];
    twilioNumber: Scalars['String']['output'];
    type: AccountType;
    unreadMessages: Scalars['Int']['output'];
  };

export type ClientAccountMessageHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['String']['input']>;
};

export type CourtAppearance = {
  __typename?: 'CourtAppearance';
  assignedStaff: Array<StaffAccount>;
  assistanceAddressed?: Maybe<Scalars['Boolean']['output']>;
  assistanceRequest?: Maybe<Scalars['String']['output']>;
  caseNumber: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  confirmedDate?: Maybe<Scalars['Time']['output']>;
  courtDate: Scalars['Time']['output'];
  courtLocation: Scalars['String']['output'];
  courtRoom: Scalars['String']['output'];
  hearingType: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  online?: Maybe<Scalars['Boolean']['output']>;
  outcomes: Array<Scalars['String']['output']>;
  releaseCondition: Scalars['String']['output'];
  topCharge: Scalars['String']['output'];
};

export type Device = Node & {
  __typename?: 'Device';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  optedOut: Scalars['Boolean']['output'];
  owner: Account;
  token?: Maybe<Scalars['String']['output']>;
  type: DeviceType;
};

export type DeviceInfo = {
  batteryLevel?: InputMaybe<Scalars['Float']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  buildId?: InputMaybe<Scalars['String']['input']>;
  buildNo?: InputMaybe<Scalars['String']['input']>;
  bundleId?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  freeSpace?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  systemName?: InputMaybe<Scalars['String']['input']>;
  systemVersion?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum DeviceType {
  Android = 'ANDROID',
  Dummy = 'DUMMY',
  Ios = 'IOS',
  Mobile = 'MOBILE',
  Rpc = 'RPC',
  Web = 'WEB',
}

export type Exposure = {
  entity: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  exposureId: Scalars['ID']['input'];
  extra?: InputMaybe<Scalars['String']['input']>;
  feature: Scalars['String']['input'];
  featureName: Scalars['String']['input'];
  repeat?: InputMaybe<Scalars['Boolean']['input']>;
  selectedVariant: Scalars['String']['input'];
  selectedVariantValue: Scalars['String']['input'];
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
  trace?: InputMaybe<Scalars['String']['input']>;
  ts: Scalars['Time']['input'];
};

export type FsmConfig = {
  __typename?: 'FSMConfig';
  graph: Scalars['String']['output'];
  meta: FsmMeta;
};

export type FsmMeta = {
  __typename?: 'FSMMeta';
  initial: Scalars['String']['output'];
  nestedStates: Array<Array<Array<Scalars['String']['output']>>>;
  states: Array<Scalars['String']['output']>;
  transitions: Array<FsmTx>;
};

export type FsmTx = {
  __typename?: 'FSMTx';
  actions: Array<Scalars['String']['output']>;
  destination: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: Array<Scalars['String']['output']>;
};

export type FeatureAssignment = {
  __typename?: 'FeatureAssignment';
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  featureName: Scalars['String']['output'];
  ts: Scalars['Time']['output'];
  value: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type Gateway = Node & {
  __typename?: 'Gateway';
  address: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum LogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Fatal = 'FATAL',
  Info = 'INFO',
  Warning = 'WARNING',
}

export type LogRecord = {
  data?: InputMaybe<Scalars['String']['input']>;
  deviceInfo: DeviceInfo;
  deviceTs: Scalars['Time']['input'];
  level: LogLevel;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Message = Node & {
  __typename?: 'Message';
  content: Scalars['String']['output'];
  destination?: Maybe<MsgNode>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  mediaUrls: Array<MsgMedia>;
  meta: MsgMeta;
  sent: Scalars['Time']['output'];
  seq: Scalars['Int']['output'];
  source: MsgNode;
  status?: Maybe<MsgStatus>;
};

export type MsgMedia = {
  __typename?: 'MsgMedia';
  contentType: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parent: Message;
  uri: Scalars['String']['output'];
};

export type MsgMeta = {
  __typename?: 'MsgMeta';
  tags: Array<Scalars['String']['output']>;
};

export type MsgNode = {
  __typename?: 'MsgNode';
  account?: Maybe<Account>;
  device?: Maybe<Device>;
};

export enum MsgStatus {
  Accepted = 'ACCEPTED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  NotSent = 'NOT_SENT',
  Queued = 'QUEUED',
  Received = 'RECEIVED',
  Sent = 'SENT',
  Undelivered = 'UNDELIVERED',
  Void = 'VOID',
}

export type Mutation = {
  __typename?: 'Mutation';
  completeReview: ReviewQueueEntry;
  log: Scalars['Void']['output'];
  logExposure: Scalars['Void']['output'];
  login?: Maybe<StaffAccount>;
  markSeenEvents: BadgeInfo;
  markThreadForReview: ReviewQueueEntry;
  registerAgent: StaffAccount;
  registerDevice: Device;
  retrySendSms: Message;
  sendSms: Message;
  unregisterDevice: Device;
  updateFsmState: Scalars['String']['output'];
  updateStaff: StaffAccount;
};

export type MutationCompleteReviewArgs = {
  reviewQueueEntryId: Scalars['ID']['input'];
};

export type MutationLogArgs = {
  record: LogRecord;
};

export type MutationLogExposureArgs = {
  data: Exposure;
};

export type MutationMarkSeenEventsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type MutationMarkThreadForReviewArgs = {
  clientAccountId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  reason: ReviewQueueReason;
};

export type MutationRegisterAgentArgs = {
  deviceId: Scalars['ID']['input'];
};

export type MutationRegisterDeviceArgs = {
  input: NewDevice;
};

export type MutationRetrySendSmsArgs = {
  messageId: Scalars['ID']['input'];
};

export type MutationSendSmsArgs = {
  content: Scalars['String']['input'];
  dummy?: InputMaybe<Scalars['Boolean']['input']>;
  fromDeviceId: Scalars['ID']['input'];
  meta?: InputMaybe<NewMsgMeta>;
  toAccountId: Scalars['ID']['input'];
};

export type MutationUnregisterDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUpdateFsmStateArgs = {
  clientAccountId: Scalars['ID']['input'];
  newState: Scalars['String']['input'];
};

export type MutationUpdateStaffArgs = {
  data: StaffAccountUpdate;
};

export type NewDevice = {
  id: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  type: DeviceType;
};

export type NewMsgMeta = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NotifInfo = {
  __typename?: 'NotifInfo';
  created: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['String']['output'];
  published?: Maybe<Scalars['Time']['output']>;
  seen?: Maybe<Scalars['Time']['output']>;
  targetAccount: StaffAccount;
  type: Scalars['String']['output'];
};

export type OAuth2ClientConfig = {
  __typename?: 'OAuth2ClientConfig';
  clientId: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type OAuth2Config = {
  __typename?: 'OAuth2Config';
  accessType: Scalars['String']['output'];
  authEndpoint: Scalars['String']['output'];
  /** @deprecated Use mobileAppClient.clientId */
  clientId: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  mobileAppClient: OAuth2ClientConfig;
  scopes: Array<Scalars['String']['output']>;
  /** @deprecated Use mobileAppClient.secret */
  secret: Scalars['String']['output'];
  state: Scalars['String']['output'];
  tokenEndpoint: Scalars['String']['output'];
  webClient: OAuth2ClientConfig;
};

export type OrgConfig = {
  __typename?: 'OrgConfig';
  googleTranslateKey?: Maybe<Scalars['String']['output']>;
  oauth2?: Maybe<OAuth2Config>;
  style?: Maybe<OrgStyle>;
};

export type OrgLoginStyle = {
  __typename?: 'OrgLoginStyle';
  bgColor?: Maybe<Scalars['String']['output']>;
  btnColor?: Maybe<Scalars['String']['output']>;
  btnTextColor?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  signInText?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type OrgStyle = {
  __typename?: 'OrgStyle';
  accentColor?: Maybe<Scalars['String']['output']>;
  login?: Maybe<OrgLoginStyle>;
};

export type Query = {
  __typename?: 'Query';
  allCourtDatesWithinNDays: Array<ClientAccount>;
  clientConfig: OrgConfig;
  clients: Array<ClientAccount>;
  featureAssignments: Array<FeatureAssignment>;
  fsm: FsmConfig;
  getMessageHistory: Array<Message>;
  hasMoreClients: Scalars['Boolean']['output'];
  hasMoreMessages: Scalars['Boolean']['output'];
  hasMoreStaff: Scalars['Boolean']['output'];
  node?: Maybe<Node>;
  nonStandardReplies: Array<Message>;
  reviewQueue: ReviewQueueConnection;
  reviewQueueEntry?: Maybe<ReviewQueueEntry>;
  staff: Array<StaffAccount>;
};

export type QueryAllCourtDatesWithinNDaysArgs = {
  nDays: Scalars['Int']['input'];
};

export type QueryClientsArgs = {
  interacted?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  staffId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFeatureAssignmentsArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetMessageHistoryArgs = {
  clientAccountID?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHasMoreMessagesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryNonStandardRepliesArgs = {
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
};

export type QueryReviewQueueArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type QueryReviewQueueEntryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryStaffArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewQueueConnection = {
  __typename?: 'ReviewQueueConnection';
  entries: Array<ReviewQueueEntry>;
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ReviewQueueEntry = Node & {
  __typename?: 'ReviewQueueEntry';
  client: ClientAccount;
  clientAccountId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastMessage?: Maybe<Message>;
  lastMessageId?: Maybe<Scalars['ID']['output']>;
  lastReviewTs?: Maybe<Scalars['Time']['output']>;
  lastReviewer?: Maybe<StaffAccount>;
  lastReviewerAccountId?: Maybe<Scalars['ID']['output']>;
  markedForReviewReason: ReviewQueueReason;
  markedForReviewTs: Scalars['Time']['output'];
  needsReview: Scalars['Boolean']['output'];
};

export enum ReviewQueueReason {
  CourtDateSoon = 'COURT_DATE_SOON',
  Manual = 'MANUAL',
  MsgIn = 'MSG_IN',
  MsgOutAuto = 'MSG_OUT_AUTO',
  Other = 'OTHER',
}

export enum Role {
  Admin = 'ADMIN',
  Staff = 'STAFF',
}

export type StaffAccount = Account &
  Node & {
    __typename?: 'StaffAccount';
    clientList?: Maybe<Array<ClientAccount>>;
    devices?: Maybe<Array<Device>>;
    firstName: Scalars['String']['output'];
    followUpChats: Array<Message>;
    fullName: Scalars['String']['output'];
    hasMoreFollowUps: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    isActive: Scalars['Boolean']['output'];
    lastName: Scalars['String']['output'];
    officePhoneNumber: Scalars['String']['output'];
    roles: Array<Role>;
    type: AccountType;
  };

export type StaffAccountClientListArgs = {
  interacted?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type StaffAccountFollowUpChatsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type StaffAccountUpdate = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  roles: Array<Role>;
};

export type UnknownAccount = Account &
  Node & {
    __typename?: 'UnknownAccount';
    devices?: Maybe<Array<Device>>;
    firstName: Scalars['String']['output'];
    fsmState?: Maybe<Scalars['String']['output']>;
    fullName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastName: Scalars['String']['output'];
    messageHistory?: Maybe<Array<Message>>;
    mobilePhoneNumber: Scalars['String']['output'];
    twilioNumber: Scalars['String']['output'];
    type: AccountType;
  };

export type AckMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AckMutation = {
  __typename?: 'Mutation';
  markSeenEvents: {__typename?: 'BadgeInfo'; unread: any};
};

export type AllClientsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  staffId?: InputMaybe<Scalars['ID']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  interacted?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AllClientsQuery = {
  __typename?: 'Query';
  hasMoreClients: boolean;
  clients: Array<{
    __typename?: 'ClientAccount';
    id: string;
    fullName: string;
    isActive: boolean;
    unreadMessages: number;
    lastMessage?: {
      __typename?: 'Message';
      sent: any;
      seq: number;
      content: string;
      source: {
        __typename?: 'MsgNode';
        account?:
          | {__typename?: 'AssociateAccount'; id: string}
          | {__typename?: 'ClientAccount'; id: string}
          | {__typename?: 'StaffAccount'; id: string}
          | {__typename?: 'UnknownAccount'; id: string}
          | null;
      };
    } | null;
  }>;
};

export type AllStaffQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type AllStaffQuery = {
  __typename?: 'Query';
  hasMoreStaff: boolean;
  staff: Array<{
    __typename?: 'StaffAccount';
    id: string;
    fullName: string;
    roles: Array<Role>;
    isActive: boolean;
    type: AccountType;
    devices?: Array<{
      __typename?: 'Device';
      id: string;
      address?: string | null;
      type: DeviceType;
    }> | null;
  }>;
};

export type AppConfigQueryVariables = Exact<{[key: string]: never}>;

export type AppConfigQuery = {
  __typename?: 'Query';
  clientConfig: {
    __typename?: 'OrgConfig';
    googleTranslateKey?: string | null;
    oauth2?: {
      __typename?: 'OAuth2Config';
      issuer: string;
      scopes: Array<string>;
      authEndpoint: string;
      tokenEndpoint: string;
      state: string;
      accessType: string;
      webClient: {
        __typename?: 'OAuth2ClientConfig';
        clientId: string;
        redirectUrl: string;
      };
    } | null;
    style?: {
      __typename?: 'OrgStyle';
      accentColor?: string | null;
      login?: {
        __typename?: 'OrgLoginStyle';
        logo?: string | null;
        bgColor?: string | null;
        textColor?: string | null;
        btnColor?: string | null;
        btnTextColor?: string | null;
        signInText?: string | null;
      } | null;
    } | null;
  };
};

export type ChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
}>;

export type ChatQuery = {
  __typename?: 'Query';
  hasMoreMessages: boolean;
  getMessageHistory: Array<{
    __typename?: 'Message';
    id: string;
    content: string;
    seq: number;
    sent: any;
    status?: MsgStatus | null;
    errorCode?: number | null;
    meta: {__typename?: 'MsgMeta'; tags: Array<string>};
    mediaUrls: Array<{
      __typename?: 'MsgMedia';
      uri: string;
      contentType: string;
    }>;
    destination?: {
      __typename?: 'MsgNode';
      account?:
        | {__typename?: 'AssociateAccount'; id: string; fullName: string}
        | {__typename?: 'ClientAccount'; id: string; fullName: string}
        | {__typename?: 'StaffAccount'; id: string; fullName: string}
        | {__typename?: 'UnknownAccount'; id: string; fullName: string}
        | null;
    } | null;
    source: {
      __typename?: 'MsgNode';
      account?:
        | {
            __typename?: 'AssociateAccount';
            id: string;
            fullName: string;
            client: {
              __typename?: 'ClientAccount';
              id: string;
              fullName: string;
            };
          }
        | {__typename?: 'ClientAccount'; id: string; fullName: string}
        | {__typename?: 'StaffAccount'; id: string; fullName: string}
        | {__typename?: 'UnknownAccount'; id: string; fullName: string}
        | null;
    };
  }>;
};

export type ClientInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  idAsStr: Scalars['String']['input'];
  admin: Scalars['Boolean']['input'];
}>;

export type ClientInfoQuery = {
  __typename?: 'Query';
  fsm?: {
    __typename?: 'FSMConfig';
    meta: {__typename?: 'FSMMeta'; nestedStates: Array<Array<Array<string>>>};
  };
  featureAssignments?: Array<{
    __typename?: 'FeatureAssignment';
    featureName: string;
    variant: string;
    value: string;
  }>;
  node?:
    | {__typename?: 'AssociateAccount'}
    | {
        __typename?: 'ClientAccount';
        id: string;
        fullName: string;
        isActive: boolean;
        language: string;
        gender: string;
        externalAppLink?: string | null;
        twilioNumber: string;
        fsmState?: string | null;
        email: string;
        address: string;
        courtDates: Array<{
          __typename?: 'CourtAppearance';
          courtDate: any;
          courtRoom: string;
          courtLocation: string;
          caseNumber: string;
          topCharge: string;
          notes: string;
          online?: boolean | null;
          confirmedDate?: any | null;
        }>;
        devices?: Array<{
          __typename?: 'Device';
          id: string;
          type: DeviceType;
          address?: string | null;
          optedOut: boolean;
        }> | null;
        assignedStaff: Array<{
          __typename?: 'StaffAccount';
          id: string;
          fullName: string;
          roles: Array<Role>;
        }>;
      }
    | {__typename?: 'Device'}
    | {__typename?: 'Gateway'}
    | {__typename?: 'Message'}
    | {__typename?: 'ReviewQueueEntry'}
    | {__typename?: 'StaffAccount'}
    | {__typename?: 'UnknownAccount'}
    | null;
};

export type CompleteReviewMutationVariables = Exact<{
  reviewQueueEntryId: Scalars['ID']['input'];
}>;

export type CompleteReviewMutation = {
  __typename?: 'Mutation';
  completeReview: {
    __typename?: 'ReviewQueueEntry';
    id: string;
    lastReviewerAccountId?: string | null;
    lastReviewTs?: any | null;
  };
};

export type FollowUpThreadsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type FollowUpThreadsQuery = {
  __typename?: 'Query';
  node?:
    | {__typename?: 'AssociateAccount'; id: string}
    | {__typename?: 'ClientAccount'; id: string}
    | {__typename?: 'Device'; id: string}
    | {__typename?: 'Gateway'; id: string}
    | {__typename?: 'Message'; id: string}
    | {__typename?: 'ReviewQueueEntry'; id: string}
    | {
        __typename?: 'StaffAccount';
        hasMoreFollowUps: boolean;
        id: string;
        followUpChats: Array<{
          __typename?: 'Message';
          id: string;
          content: string;
          seq: number;
          sent: any;
          status?: MsgStatus | null;
          errorCode?: number | null;
          meta: {__typename?: 'MsgMeta'; tags: Array<string>};
          mediaUrls: Array<{
            __typename?: 'MsgMedia';
            uri: string;
            contentType: string;
          }>;
          destination?: {
            __typename?: 'MsgNode';
            account?:
              | {__typename?: 'AssociateAccount'; id: string; fullName: string}
              | {__typename?: 'ClientAccount'; id: string; fullName: string}
              | {__typename?: 'StaffAccount'; id: string; fullName: string}
              | {__typename?: 'UnknownAccount'; id: string; fullName: string}
              | null;
          } | null;
          source: {
            __typename?: 'MsgNode';
            account?:
              | {
                  __typename?: 'AssociateAccount';
                  id: string;
                  fullName: string;
                  client: {
                    __typename?: 'ClientAccount';
                    id: string;
                    fullName: string;
                  };
                }
              | {__typename?: 'ClientAccount'; id: string; fullName: string}
              | {__typename?: 'StaffAccount'; id: string; fullName: string}
              | {__typename?: 'UnknownAccount'; id: string; fullName: string}
              | null;
          };
        }>;
      }
    | {__typename?: 'UnknownAccount'; id: string}
    | null;
};

export type FsmStatesQueryVariables = Exact<{[key: string]: never}>;

export type FsmStatesQuery = {
  __typename?: 'Query';
  fsm: {
    __typename?: 'FSMConfig';
    meta: {__typename?: 'FSMMeta'; states: Array<string>};
  };
};

export type GetMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetMessageQuery = {
  __typename?: 'Query';
  node?:
    | {__typename?: 'AssociateAccount'}
    | {__typename?: 'ClientAccount'}
    | {__typename?: 'Device'}
    | {__typename?: 'Gateway'}
    | {
        __typename?: 'Message';
        id: string;
        content: string;
        seq: number;
        sent: any;
        status?: MsgStatus | null;
        errorCode?: number | null;
        meta: {__typename?: 'MsgMeta'; tags: Array<string>};
        mediaUrls: Array<{
          __typename?: 'MsgMedia';
          uri: string;
          contentType: string;
        }>;
        destination?: {
          __typename?: 'MsgNode';
          account?:
            | {__typename?: 'AssociateAccount'; id: string; fullName: string}
            | {__typename?: 'ClientAccount'; id: string; fullName: string}
            | {__typename?: 'StaffAccount'; id: string; fullName: string}
            | {__typename?: 'UnknownAccount'; id: string; fullName: string}
            | null;
        } | null;
        source: {
          __typename?: 'MsgNode';
          account?:
            | {
                __typename?: 'AssociateAccount';
                id: string;
                fullName: string;
                client: {
                  __typename?: 'ClientAccount';
                  id: string;
                  fullName: string;
                };
              }
            | {__typename?: 'ClientAccount'; id: string; fullName: string}
            | {__typename?: 'StaffAccount'; id: string; fullName: string}
            | {__typename?: 'UnknownAccount'; id: string; fullName: string}
            | null;
        };
      }
    | {__typename?: 'ReviewQueueEntry'}
    | {__typename?: 'StaffAccount'}
    | {__typename?: 'UnknownAccount'}
    | null;
};

export type GraphQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GraphQuery = {
  __typename?: 'Query';
  node?:
    | {__typename?: 'AssociateAccount'}
    | {__typename?: 'ClientAccount'; fsmState?: string | null; fsmGraph: string}
    | {__typename?: 'Device'}
    | {__typename?: 'Gateway'}
    | {__typename?: 'Message'}
    | {__typename?: 'ReviewQueueEntry'}
    | {__typename?: 'StaffAccount'}
    | {__typename?: 'UnknownAccount'}
    | null;
};

export type LoginMutationVariables = Exact<{[key: string]: never}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login?: {__typename?: 'StaffAccount'; id: string; roles: Array<Role>} | null;
};

export type MyDevicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type MyDevicesQuery = {
  __typename?: 'Query';
  node?:
    | {__typename?: 'AssociateAccount'}
    | {__typename?: 'ClientAccount'}
    | {__typename?: 'Device'}
    | {__typename?: 'Gateway'}
    | {__typename?: 'Message'}
    | {__typename?: 'ReviewQueueEntry'}
    | {
        __typename?: 'StaffAccount';
        devices?: Array<{
          __typename?: 'Device';
          id: string;
          address?: string | null;
          type: DeviceType;
        }> | null;
      }
    | {__typename?: 'UnknownAccount'}
    | null;
};

export type NonStandardRepliesQueryVariables = Exact<{
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
}>;

export type NonStandardRepliesQuery = {
  __typename?: 'Query';
  nonStandardReplies: Array<{
    __typename?: 'Message';
    id: string;
    content: string;
    seq: number;
    sent: any;
    status?: MsgStatus | null;
    errorCode?: number | null;
    meta: {__typename?: 'MsgMeta'; tags: Array<string>};
    mediaUrls: Array<{
      __typename?: 'MsgMedia';
      uri: string;
      contentType: string;
    }>;
    destination?: {
      __typename?: 'MsgNode';
      account?:
        | {__typename?: 'AssociateAccount'; id: string; fullName: string}
        | {__typename?: 'ClientAccount'; id: string; fullName: string}
        | {__typename?: 'StaffAccount'; id: string; fullName: string}
        | {__typename?: 'UnknownAccount'; id: string; fullName: string}
        | null;
    } | null;
    source: {
      __typename?: 'MsgNode';
      account?:
        | {
            __typename?: 'AssociateAccount';
            id: string;
            fullName: string;
            client: {
              __typename?: 'ClientAccount';
              id: string;
              fullName: string;
            };
          }
        | {__typename?: 'ClientAccount'; id: string; fullName: string}
        | {__typename?: 'StaffAccount'; id: string; fullName: string}
        | {__typename?: 'UnknownAccount'; id: string; fullName: string}
        | null;
    };
  }>;
};

export type RegisterDeviceMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
  ownerId: Scalars['ID']['input'];
  deviceType: DeviceType;
}>;

export type RegisterDeviceMutation = {
  __typename?: 'Mutation';
  registerDevice: {
    __typename?: 'Device';
    id: string;
    owner:
      | {__typename?: 'AssociateAccount'; fullName: string}
      | {__typename?: 'ClientAccount'; fullName: string}
      | {__typename?: 'StaffAccount'; fullName: string}
      | {__typename?: 'UnknownAccount'; fullName: string};
  };
};

export type GetReviewQueueQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type GetReviewQueueQuery = {
  __typename?: 'Query';
  reviewQueue: {
    __typename?: 'ReviewQueueConnection';
    totalCount: number;
    hasNextPage: boolean;
    entries: Array<{
      __typename?: 'ReviewQueueEntry';
      id: string;
      needsReview: boolean;
      markedForReviewTs: any;
      markedForReviewReason: ReviewQueueReason;
      lastReviewTs?: any | null;
      client: {__typename?: 'ClientAccount'; id: string; fullName: string};
      lastReviewer?: {
        __typename?: 'StaffAccount';
        id: string;
        fullName: string;
      } | null;
      lastMessage?: {
        __typename?: 'Message';
        id: string;
        content: string;
        seq: number;
        sent: any;
        status?: MsgStatus | null;
        errorCode?: number | null;
        meta: {__typename?: 'MsgMeta'; tags: Array<string>};
        mediaUrls: Array<{
          __typename?: 'MsgMedia';
          uri: string;
          contentType: string;
        }>;
        destination?: {
          __typename?: 'MsgNode';
          account?:
            | {__typename?: 'AssociateAccount'; id: string; fullName: string}
            | {__typename?: 'ClientAccount'; id: string; fullName: string}
            | {__typename?: 'StaffAccount'; id: string; fullName: string}
            | {__typename?: 'UnknownAccount'; id: string; fullName: string}
            | null;
        } | null;
        source: {
          __typename?: 'MsgNode';
          account?:
            | {
                __typename?: 'AssociateAccount';
                id: string;
                fullName: string;
                client: {
                  __typename?: 'ClientAccount';
                  id: string;
                  fullName: string;
                };
              }
            | {__typename?: 'ClientAccount'; id: string; fullName: string}
            | {__typename?: 'StaffAccount'; id: string; fullName: string}
            | {__typename?: 'UnknownAccount'; id: string; fullName: string}
            | null;
        };
      } | null;
    }>;
  };
};

export type SendMutationVariables = Exact<{
  content: Scalars['String']['input'];
  fromDeviceId: Scalars['ID']['input'];
  toAccountId: Scalars['ID']['input'];
}>;

export type SendMutation = {
  __typename?: 'Mutation';
  sendSms: {
    __typename?: 'Message';
    id: string;
    content: string;
    sent: any;
    seq: number;
    status?: MsgStatus | null;
    errorCode?: number | null;
    mediaUrls: Array<{
      __typename?: 'MsgMedia';
      uri: string;
      contentType: string;
    }>;
    destination?: {
      __typename?: 'MsgNode';
      account?:
        | {__typename?: 'AssociateAccount'; id: string}
        | {__typename?: 'ClientAccount'; id: string}
        | {__typename?: 'StaffAccount'; id: string}
        | {__typename?: 'UnknownAccount'; id: string}
        | null;
      device?: {__typename?: 'Device'; id: string} | null;
    } | null;
    source: {
      __typename?: 'MsgNode';
      account?:
        | {__typename?: 'AssociateAccount'; fullName: string}
        | {__typename?: 'ClientAccount'; fullName: string}
        | {__typename?: 'StaffAccount'; fullName: string}
        | {__typename?: 'UnknownAccount'; fullName: string}
        | null;
    };
  };
};

export type UnregisterDeviceMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;

export type UnregisterDeviceMutation = {
  __typename?: 'Mutation';
  unregisterDevice: {__typename?: 'Device'; id: string};
};

export type UpdateFsmStateMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  newState: Scalars['String']['input'];
}>;

export type UpdateFsmStateMutation = {
  __typename?: 'Mutation';
  updateFsmState: string;
};

export type UpdateStaffMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  roles: Array<Role> | Role;
}>;

export type UpdateStaffMutation = {
  __typename?: 'Mutation';
  updateStaff: {
    __typename?: 'StaffAccount';
    id: string;
    isActive: boolean;
    roles: Array<Role>;
  };
};

export type ClientProfileFragment = {
  __typename?: 'ClientAccount';
  id: string;
  fullName: string;
  isActive: boolean;
  unreadMessages: number;
  lastMessage?: {
    __typename?: 'Message';
    sent: any;
    seq: number;
    content: string;
    source: {
      __typename?: 'MsgNode';
      account?:
        | {__typename?: 'AssociateAccount'; id: string}
        | {__typename?: 'ClientAccount'; id: string}
        | {__typename?: 'StaffAccount'; id: string}
        | {__typename?: 'UnknownAccount'; id: string}
        | null;
    };
  } | null;
};

export type MessageContentFragment = {
  __typename?: 'Message';
  id: string;
  content: string;
  seq: number;
  sent: any;
  status?: MsgStatus | null;
  errorCode?: number | null;
  meta: {__typename?: 'MsgMeta'; tags: Array<string>};
  mediaUrls: Array<{__typename?: 'MsgMedia'; uri: string; contentType: string}>;
  destination?: {
    __typename?: 'MsgNode';
    account?:
      | {__typename?: 'AssociateAccount'; id: string; fullName: string}
      | {__typename?: 'ClientAccount'; id: string; fullName: string}
      | {__typename?: 'StaffAccount'; id: string; fullName: string}
      | {__typename?: 'UnknownAccount'; id: string; fullName: string}
      | null;
  } | null;
  source: {
    __typename?: 'MsgNode';
    account?:
      | {
          __typename?: 'AssociateAccount';
          id: string;
          fullName: string;
          client: {__typename?: 'ClientAccount'; id: string; fullName: string};
        }
      | {__typename?: 'ClientAccount'; id: string; fullName: string}
      | {__typename?: 'StaffAccount'; id: string; fullName: string}
      | {__typename?: 'UnknownAccount'; id: string; fullName: string}
      | null;
  };
};

export type SentMessageFragment = {
  __typename?: 'Message';
  id: string;
  content: string;
  sent: any;
  seq: number;
  status?: MsgStatus | null;
  errorCode?: number | null;
  mediaUrls: Array<{__typename?: 'MsgMedia'; uri: string; contentType: string}>;
  destination?: {
    __typename?: 'MsgNode';
    account?:
      | {__typename?: 'AssociateAccount'; id: string}
      | {__typename?: 'ClientAccount'; id: string}
      | {__typename?: 'StaffAccount'; id: string}
      | {__typename?: 'UnknownAccount'; id: string}
      | null;
    device?: {__typename?: 'Device'; id: string} | null;
  } | null;
  source: {
    __typename?: 'MsgNode';
    account?:
      | {__typename?: 'AssociateAccount'; fullName: string}
      | {__typename?: 'ClientAccount'; fullName: string}
      | {__typename?: 'StaffAccount'; fullName: string}
      | {__typename?: 'UnknownAccount'; fullName: string}
      | null;
  };
};

export type GetMessageStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetMessageStatusQuery = {
  __typename?: 'Query';
  node?:
    | {__typename?: 'AssociateAccount'}
    | {__typename?: 'ClientAccount'}
    | {__typename?: 'Device'}
    | {__typename?: 'Gateway'}
    | {__typename?: 'Message'; id: string; status?: MsgStatus | null}
    | {__typename?: 'ReviewQueueEntry'}
    | {__typename?: 'StaffAccount'}
    | {__typename?: 'UnknownAccount'}
    | null;
};

export const ClientProfileFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ClientProfile'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'ClientAccount'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isActive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'unreadMessages'},
            directives: [
              {kind: 'Directive', name: {kind: 'Name', value: 'client'}},
            ],
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastMessage'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
                {kind: 'Field', name: {kind: 'Name', value: 'content'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'source'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'account'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientProfileFragment, unknown>;
export const MessageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MessageContent'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'Message'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'content'}},
          {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'errorCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mediaUrls'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uri'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'destination'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'source'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'AssociateAccount'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'client'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'id'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'fullName'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageContentFragment, unknown>;
export const SentMessageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SentMessage'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'Message'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'content'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'errorCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mediaUrls'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uri'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'destination'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'device'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'source'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SentMessageFragment, unknown>;
export const AckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'Ack'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'ids'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'markSeenEvents'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'ids'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'ids'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'unread'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AckMutation, AckMutationVariables>;
export const AllClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AllClients'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'search'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'staffId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'mine'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'interacted'},
          },
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'clients'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'offset'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'search'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'search'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'staffId'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'staffId'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'mine'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'mine'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'interacted'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'interacted'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'ClientProfile'},
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'hasMoreClients'},
            directives: [
              {kind: 'Directive', name: {kind: 'Name', value: 'client'}},
            ],
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ClientProfile'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'ClientAccount'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isActive'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'unreadMessages'},
            directives: [
              {kind: 'Directive', name: {kind: 'Name', value: 'client'}},
            ],
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lastMessage'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
                {kind: 'Field', name: {kind: 'Name', value: 'content'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'source'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'account'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllClientsQuery, AllClientsQueryVariables>;
export const AllStaffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AllStaff'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'staff'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'offset'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'roles'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isActive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'devices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'hasMoreStaff'},
            directives: [
              {kind: 'Directive', name: {kind: 'Name', value: 'client'}},
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllStaffQuery, AllStaffQueryVariables>;
export const AppConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AppConfig'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'clientConfig'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'googleTranslateKey'},
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'oauth2'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'issuer'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'scopes'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'authEndpoint'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'tokenEndpoint'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'webClient'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'clientId'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'redirectUrl'},
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'accessType'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'style'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'login'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'logo'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'bgColor'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'textColor'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'btnColor'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'btnTextColor'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'signInText'},
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'accentColor'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppConfigQuery, AppConfigQueryVariables>;
export const ChatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Chat'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'getMessageHistory'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'clientAccountID'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'offset'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'MessageContent'},
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'hasMoreMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            directives: [
              {kind: 'Directive', name: {kind: 'Name', value: 'client'}},
            ],
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MessageContent'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'Message'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'content'}},
          {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'errorCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mediaUrls'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uri'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'destination'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'source'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'AssociateAccount'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'client'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'id'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'fullName'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatQuery, ChatQueryVariables>;
export const ClientInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ClientInfo'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'idAsStr'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'admin'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fsm'},
            directives: [
              {
                kind: 'Directive',
                name: {kind: 'Name', value: 'include'},
                arguments: [
                  {
                    kind: 'Argument',
                    name: {kind: 'Name', value: 'if'},
                    value: {
                      kind: 'Variable',
                      name: {kind: 'Name', value: 'admin'},
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'meta'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'nestedStates'},
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'featureAssignments'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'entityType'},
                value: {
                  kind: 'StringValue',
                  value: 'ClientEntity',
                  block: false,
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'entityId'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'idAsStr'},
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: {kind: 'Name', value: 'include'},
                arguments: [
                  {
                    kind: 'Argument',
                    name: {kind: 'Name', value: 'if'},
                    value: {
                      kind: 'Variable',
                      name: {kind: 'Name', value: 'admin'},
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'featureName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'variant'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'node'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ClientAccount'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isActive'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'language'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'gender'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'externalAppLink'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'twilioNumber'},
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'fsmState'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'courtDates'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'courtDate'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'courtRoom'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'courtLocation'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'caseNumber'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'topCharge'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'notes'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'online'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'confirmedDate'},
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'devices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'type'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'address'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'optedOut'},
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'assignedStaff'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'fullName'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'roles'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientInfoQuery, ClientInfoQueryVariables>;
export const CompleteReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CompleteReview'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'reviewQueueEntryId'},
          },
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'completeReview'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'reviewQueueEntryId'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'reviewQueueEntryId'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lastReviewerAccountId'},
                },
                {kind: 'Field', name: {kind: 'Name', value: 'lastReviewTs'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteReviewMutation,
  CompleteReviewMutationVariables
>;
export const FollowUpThreadsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'FollowUpThreads'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'node'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'StaffAccount'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'followUpChats'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'limit'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'offset'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'MessageContent'},
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'hasMoreFollowUps'},
                        directives: [
                          {
                            kind: 'Directive',
                            name: {kind: 'Name', value: 'client'},
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MessageContent'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'Message'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'content'}},
          {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'errorCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mediaUrls'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uri'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'destination'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'source'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'AssociateAccount'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'client'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'id'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'fullName'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FollowUpThreadsQuery,
  FollowUpThreadsQueryVariables
>;
export const FsmStatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'FsmStates'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fsm'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'meta'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'states'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FsmStatesQuery, FsmStatesQueryVariables>;
export const GetMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'GetMessage'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'node'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'MessageContent'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MessageContent'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'Message'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'content'}},
          {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'errorCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mediaUrls'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uri'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'destination'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'source'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'AssociateAccount'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'client'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'id'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'fullName'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMessageQuery, GetMessageQueryVariables>;
export const GraphDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'Graph'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'node'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ClientAccount'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fsmState'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fsmGraph'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GraphQuery, GraphQueryVariables>;
export const LoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'Login'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'login'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'roles'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const MyDevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'MyDevices'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'node'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'StaffAccount'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'devices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'address'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'type'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyDevicesQuery, MyDevicesQueryVariables>;
export const NonStandardRepliesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'NonStandardReplies'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Time'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'to'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Time'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'nonStandardReplies'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'from'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'from'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'to'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'to'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'MessageContent'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MessageContent'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'Message'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'content'}},
          {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'errorCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mediaUrls'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uri'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'destination'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'source'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'AssociateAccount'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'client'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'id'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'fullName'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NonStandardRepliesQuery,
  NonStandardRepliesQueryVariables
>;
export const RegisterDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'RegisterDevice'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deviceId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'token'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'ownerId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'deviceType'},
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {kind: 'Name', value: 'DeviceType'},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'registerDevice'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'id'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'deviceId'},
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'ownerId'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'ownerId'},
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'type'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'deviceType'},
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'token'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'token'},
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'owner'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterDeviceMutation,
  RegisterDeviceMutationVariables
>;
export const GetReviewQueueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'GetReviewQueue'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'reviewQueue'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'offset'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'entries'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'client'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'fullName'},
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'needsReview'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'markedForReviewTs'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'markedForReviewReason'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'lastReviewer'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'fullName'},
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'lastMessage'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'MessageContent'},
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'lastReviewTs'},
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'hasNextPage'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MessageContent'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'Message'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'content'}},
          {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'errorCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'meta'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'tags'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mediaUrls'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uri'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'destination'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'source'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'AssociateAccount'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'client'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'id'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'fullName'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReviewQueueQuery, GetReviewQueueQueryVariables>;
export const SendDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'Send'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'content'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'fromDeviceId'},
          },
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'toAccountId'},
          },
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendSms'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'content'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'content'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'fromDeviceId'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'fromDeviceId'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'toAccountId'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'toAccountId'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'SentMessage'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SentMessage'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'Message'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'content'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sent'}},
          {kind: 'Field', name: {kind: 'Name', value: 'seq'}},
          {kind: 'Field', name: {kind: 'Name', value: 'status'}},
          {kind: 'Field', name: {kind: 'Name', value: 'errorCode'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'mediaUrls'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uri'}},
                {kind: 'Field', name: {kind: 'Name', value: 'contentType'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'destination'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'device'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'source'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'account'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMutation, SendMutationVariables>;
export const UnregisterDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UnregisterDevice'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deviceId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'unregisterDevice'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'deviceId'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnregisterDeviceMutation,
  UnregisterDeviceMutationVariables
>;
export const UpdateFsmStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateFsmState'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'accountId'},
          },
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'newState'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateFsmState'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'clientAccountId'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'accountId'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'newState'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'newState'},
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFsmStateMutation,
  UpdateFsmStateMutationVariables
>;
export const UpdateStaffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateStaff'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'isActive'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'roles'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'Role'}},
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateStaff'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'data'},
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'id'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'id'},
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'isActive'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'isActive'},
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'roles'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'roles'},
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isActive'}},
                {kind: 'Field', name: {kind: 'Name', value: 'roles'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateStaffMutation, UpdateStaffMutationVariables>;
export const GetMessageStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'getMessageStatus'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'node'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'Message'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMessageStatusQuery,
  GetMessageStatusQueryVariables
>;
